// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-product__buy-button{position:relative}.plv-iar-product__buy-button__render{z-index:10}.plv-iar-product__buy-button__inner{position:absolute;z-index:10;width:100%;height:100%;top:0;left:0;cursor:pointer}.plv-iar-product__buy-button__inner.plv-iar-product__buy-button__inner--disabled{cursor:not-allowed}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
